// extracted by mini-css-extract-plugin
export default {"rowcard":"rows_rowcard__n8KxR","row":"rows_row__e9NJn","titlerow":"rows_titlerow__GTpjK"};